import StyledToggleButton from "@/react/components/styled/StyledToggleButton";
import React from "react";

export const booleanEdit = (row, field, onChange) => (
  <StyledToggleButton
    isChecked={Boolean(row[field])}
    label={Boolean(row[field]) ? "Enabled" : "Disabled"}
    onChange={() => onChange(row, field, !Boolean(row[field]))}
  />
);
